import user from "../../configs/User";

function suspenseResource() {
  let status = "loading";
  let result;
  let suspender = user.init().then(
    () => {
      status = "success";
      result = true;
    },
    (error) => {
      status = "error";
      result = error;
    }
  );

  return {
    read() {
      if (status === "loading") {
        throw suspender;
      } else if (status === "error") {
        throw result;
      } else if (status === "success") {
        return result;
      }
    },
  };
}

const resource = suspenseResource();

const AuthProvider = ({ children }) => {
  resource.read();

  return children;
};

export default AuthProvider;
